import { Directive, HostBinding, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

/**
 * Applies the .was-validated CSS class to any `NgForm`s that were submitted.
 *
 * Since Angular forms are validated before the are submitted, we can just
 * check the `NgForm`'s submitted flag. This allows us to mimic Bootstrap's
 * behavior that only shows form validation error messages after validation
 * has occurred.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'form'
})
export class BootstrapFormDirective {
  private hideValidationClasses = false;

  @Input() set novalidate(val: string | boolean) {
    this.hideValidationClasses = val === '' || Boolean(val);
  }

  get showValidationClasses() {
    return !this.hideValidationClasses;
  }

  constructor(private ngForm: NgForm) {}

  @HostBinding('class.was-validated')
  get validatedStyle(): boolean {
    return this.ngForm.submitted && this.showValidationClasses;
  }
}
